import { forwardRef, type ChangeEvent, type InputHTMLAttributes } from 'react'
import { sanitizeNumber, type SanitizeNumberOptions } from '@shared/utils'
import { Input } from './input'

interface NumberInputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'inputMode'>,
    SanitizeNumberOptions {}

/**
 * Ô nhập số: bỏ ngay mọi ký tự không phải số khi gõ hoặc dán (lỗi demo 30/09 — ô kỳ hạn gõ được chữ; `inputMode` chỉ đổi bàn phím
 * điện thoại, không chặn gì). Giá trị vẫn là CHUỖI — đọc số bằng `parseNumberVi` / chuỗi thập phân, không đổi sang `number` cho tiền.
 * Dùng được với `register` của React Hook Form lẫn ô có `value` + `onChange`.
 */
export const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
  ({ decimal = false, negative = false, onChange, ...props }, ref) => {
    const handle = (e: ChangeEvent<HTMLInputElement>) => {
      const clean = sanitizeNumber(e.target.value, { decimal, negative })
      if (clean !== e.target.value) e.target.value = clean
      onChange?.(e)
    }
    return <Input ref={ref} type="text" inputMode={decimal ? 'decimal' : 'numeric'} onChange={handle} {...props} />
  },
)
NumberInput.displayName = 'NumberInput'
